const scriptPromises: Record<string, Promise<HTMLScriptElement | never>> = {};

function loadExternalScript(src: string, scriptProperties?: Partial<Omit<HTMLScriptElement, 'src'>>): Promise<HTMLScriptElement | never> {
    try {
        if (src?.startsWith('//')) {
            src = `${document.location.protocol}${src}`;
        }
        new URL(src);
    } catch (error) {
        return Promise.reject(error);
    }

    const properties = {
        async: true,
        ...scriptProperties,
    };

    if (!scriptPromises[src]) {
        scriptPromises[src] = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.onload = () => resolve(script);
            script.onerror = (oError: string | Event) => {
                // Don't cache the failure — drop the entry (and the dead tag) so a later caller can
                // retry with a fresh script instead of reusing the rejected promise for the session.
                delete scriptPromises[src];
                script.remove();
                const detail = typeof oError === 'string' ? oError : oError.type;
                reject(new URIError(`The script ${src} didn't load correctly. ${detail}`));
            };
            Object.keys(properties).forEach(option => {
                (script as any)[option] = (properties as any)[option];
            });
            document.body.appendChild(script);
            script.src = src;
        });
    }

    return scriptPromises[src];
}

export { loadExternalScript };
